import { Autocomplete, Grid, Popper, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import globalStyles from "../../assets/styles/global.module.scss";
import phoneStyles from "../../assets/styles/componentStyles/phoneComponent.module.scss"
import contactStyles from "../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import IconsColor from './iconsColor';
import { UserContext, UserContextPayload } from '../../context/userContext'; 
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Required from './required';
import GlobalButton from './globalButton/button';
import { requestCallbackPayload, timezoneList } from '../../models/axiosModel';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { CountryCode, isValidNumberForRegion, parsePhoneNumberFromString } from 'libphonenumber-js';
import agent from '../../services/api';
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

type payloadFields  = 
    | { field: 'phone_number', value: string, data: {} | CountryData }
    | { field: 'timezone', value: timezoneList | null }
    | { field: 'callback_preferred_time', value: string | null }
    | { field: 'query', value: string } 
 

const HelpPopup = () => {
    
    const { setOpenConsultationBar, setFlagShowScheduleCall, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { genericTimezoneList } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [flagShowRequestACallbackForm, setFlagShowRequestACallbackForm] = useState<boolean>(false); 
    
    const [flagValidPhoneNumber, setFlagValidPhoneNumber] = useState<boolean>(true);
    const [payload, setPayload] = useState<requestCallbackPayload>({
        phone_number: "", 
        timezone: "", 
        callback_preferred_time: "", 
        query: "",
    });

    const helpOptions = [
        {
            title: "Chat with us",
            bgColor: "#34C65D1F",
            boxShadow: "0px 0px 2px 0px #34C65DB2", 
            icon: <IconsColor iconName="chatWithUsHelpOption" height="24" width="24"  />, 
            onClick: () => {
                window.open(" https://api.whatsapp.com/send?phone=917861834273", "_blank");
                setOpenConsultationBar(false);
            }
        },
        {
            title: "Request a Callback", 
            bgColor: "#95BEFF1F", 
            boxShadow: "0px 0px 2px 0px #95BEFF", 
            icon: <IconsColor iconName="requestACallbackHelpOption" height="24" width="24"  />, 
            onClick: () => { 
                setFlagShowRequestACallbackForm(true);
            }
        },
        {
            title: "Book a Meeting", 
            bgColor: "#6A097D0D", 
            boxShadow: "0px 0px 2px 0px #6A097D80", 
            icon: <IconsColor iconName="bookAMeetingHelpOption" height="24" width="24"  />, 
            onClick: () => { 
                setFlagShowScheduleCall(true);
                setOpenConsultationBar(false);
            }
        }
    ]

    const timeSlots = [
        "09:00 AM - 09:30 AM", "09:30 AM - 10:00 AM", "10:00 AM - 10:30 AM", "10:30 AM - 11:00 AM", "11:00 AM - 11:30 AM", "11:30 AM - 12:00 PM", "12:00 PM - 12:30 PM", 
        "12:30 PM - 01:00 PM", "01:00 PM - 01:30 PM", "01:30 PM - 02:00 PM", "02:00 PM - 02:30 PM", "02:30 PM - 03:00 PM", "03:00 PM - 03:30 PM", "03:30 PM - 04:00 PM",
        "04:00 PM - 04:30 PM", "04:30 PM - 05:00 PM", "05:00 PM - 05:30 PM", "05:30 PM - 06:00 PM", "06:00 PM - 06:30 PM", "06:30 PM - 07:00 PM", "07:00 PM - 07:30 PM", 
        "07:30 PM - 08:00 PM", "08:00 PM - 08:30 PM", "08:30 PM - 09:00 PM", "09:00 PM - 09:30 PM", "09:30 PM - 10:00 PM", "10:00 PM - 10:30 PM", "10:30 PM - 11:00 PM"
    ]

    const getTimeZoneValue = () => {
        return genericTimezoneList.find((timezone) => timezone.timezone_name == payload.timezone) ?? null
    }

    const CustomPopper = (props: any) => {
        return <Popper {...props} style={{ zIndex: 2000, width: props.anchorEl?.clientWidth }} />;
    }; 

    const getValueOfTimeSlot = () => {
        return timeSlots?.find((time) => time == payload?.callback_preferred_time) ?? null;
    }

    const checkDisableSubmitBtn = () => {
        if(payload?.phone_number?.trim()?.length == 0 || payload?.timezone?.length == 0 || payload?.callback_preferred_time?.length == 0 || !flagValidPhoneNumber){
            return true;
        }
        return false;
    }

    const onClikOfSubmit = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.createUserCallbackRequest.post(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess("Request Submitted Successfully.")
        }
        setOpenConsultationBar(false); 
        onClickOfBackBtn();
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const onChangeOfField = (data: payloadFields) => {
        let updatedPayload = payload;
        switch(data.field){
            case 'phone_number': 
                const phoneValue = '+' + data.value;
                const phoneNumber = parsePhoneNumberFromString('+' + data.value);

                if (phoneNumber && 'countryCode' in data?.data) {
                    const valid = isValidNumberForRegion(phoneNumber.number, (data?.data?.countryCode?.toUpperCase()) as CountryCode);
                    setFlagValidPhoneNumber(valid);
                } else {
                    setFlagValidPhoneNumber(false);
                }
                updatedPayload = {
                    ...updatedPayload, 
                    phone_number: phoneValue,
                }
                break;
            case 'timezone': 
                updatedPayload = {
                    ...updatedPayload, 
                    timezone: data.value ? data.value.timezone_name : "",
                }
                break;
            case 'callback_preferred_time': 
                updatedPayload = {
                    ...updatedPayload, 
                    callback_preferred_time: data.value ? data.value : "",
                }
                break;
            case 'query': 
                updatedPayload = {
                    ...updatedPayload, 
                    query: data.value ? data.value : "",
                }
                break;
        }
        setPayload(updatedPayload);  
    }

    const onClickOfBackBtn = () => {
        setFlagShowRequestACallbackForm(false);
        setPayload(({
            phone_number: "", 
            timezone: "",
            callback_preferred_time: "",
            query: "",
        }));
        setFlagValidPhoneNumber(true);
    }
    
    return (
        <>
            <Grid item className={globalStyles.requestCallbackMainGrid}>
                <Grid container gap={"20px"} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12}>
                        <Typography className={globalStyles.gotQuestionsTitle}>
                            {flagShowRequestACallbackForm ? 
                                <Grid container alignItems={"center"} gap={"12px"}>
                                    <Grid item className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} onClick={() => onClickOfBackBtn()}>
                                        <KeyboardBackspaceIcon />
                                    </Grid>
                                    <Grid item>
                                        Request a Callback
                                    </Grid>
                                </Grid>
                                : 
                                `Got questions? We're here to help! Choose how you'd like to get in touch:`
                            }
                        </Typography>
                    </Grid>
                    <Grid item xs={12}> 
                        {flagShowRequestACallbackForm ? 
                            <Grid container direction={"column"} gap={"15px"} flexWrap={"nowrap"}>
                                <Grid item xs={12}>
                                    <Grid container gap={"14px"} direction={"column"} flexWrap={"nowrap"}>
                                        <Grid item xs={12}>
                                            <Grid container gap={1} direction={"column"} flexWrap={"nowrap"}>
                                                <Grid item xs={12}>
                                                    <Typography className={globalStyles.requestCallbackQuestionTitle}>Please enter your phone number and our team will reach out to you soon! <Required /></Typography>
                                                </Grid>
                                                <Grid item xs={12}> 
                                                    <Grid item className={`${globalStyles.fullwidth} ${phoneStyles.phoneInputWrapperForRequestACallback}`}>
                                                        <PhoneInput 
                                                            value={payload.phone_number}
                                                            onChange={(value, data) => onChangeOfField({ field: "phone_number", value: value, data: data })}
                                                        />  
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid> 
                                        <Grid item xs={12}>
                                            <Grid container gap={1} direction={"column"}>
                                                <Grid item xs={12}>
                                                    <Typography className={globalStyles.requestCallbackQuestionTitle}>When is the best time to reach you? <Required /></Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        className={contactStyles.contactFilterDropdownsInPopup}
                                                        options={genericTimezoneList}
                                                        getOptionLabel={(option) => option.timezone_name}
                                                        renderInput={(params) => (<TextField {...params} placeholder='Select Timezone' />)}
                                                        value={getTimeZoneValue()} 
                                                        PopperComponent={CustomPopper}
                                                        onChange={(event, value) => onChangeOfField({ field: "timezone", value: value })}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        className={contactStyles.contactFilterDropdownsInPopup}
                                                        options={timeSlots}
                                                        getOptionLabel={(option) => option}
                                                        renderInput={(params) => (<TextField {...params} placeholder='Select Time Slot' />)}
                                                        value={getValueOfTimeSlot()} 
                                                        PopperComponent={CustomPopper}
                                                        onChange={(event, value) => onChangeOfField({ field: "callback_preferred_time", value: value })}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container gap={1} direction={"column"} flexWrap={"nowrap"}>
                                                <Grid item xs={12}>
                                                    <Typography className={globalStyles.requestCallbackQuestionTitle}>Please share your query.</Typography>
                                                </Grid> 
                                                <Grid item xs={12}>
                                                    <textarea
                                                        rows={1}
                                                        placeholder='Write your query here...'
                                                        className={globalStyles.queryTextArea}
                                                        value={payload.query}
                                                        onChange={(e) => onChangeOfField({ field: "query", value: e.target.value })}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container gap={1}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Submit"
                                                className='primaryButtonStyle' 
                                                disabled={checkDisableSubmitBtn()} 
                                                onClick={() => onClikOfSubmit()}
                                                sx={{ width: "100px" }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                className='borderedButtonStyle'
                                                sx={{ width: "100px" }}
                                                onClick={() => onClickOfBackBtn()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :
                            <Grid container direction={"column"} gap={"15px"} flexWrap={"nowrap"}>
                                {helpOptions.map((option, ind) => {
                                    return (
                                        <Grid item 
                                            key={ind} 
                                            sx={{ backgroundColor: option.bgColor, boxShadow: option.boxShadow }} 
                                            className={globalStyles.helpOptionGridItem}
                                            onClick={() => option.onClick()}
                                        >
                                            <Grid container gap={"12px"} alignItems={"center"} padding={"10px"}>
                                                <Grid item className={globalStyles.displayFlexStyle}>
                                                    {option?.icon}
                                                </Grid>
                                                <Grid item>
                                                    <Typography className={globalStyles.helpOptionTitleText}>{option?.title}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default HelpPopup
